<template>
  <ConfirmationModal
    v-if="pending"
    :message="pending.message"
    @confirmAction="answerLeave(true)"
    @cancelAction="answerLeave(false)"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { answerLeave, leaveConfirmState } from './leaveConfirm'

export default defineComponent({
  computed: {
    pending() {
      return leaveConfirmState.pending
    },
  },
  methods: {
    answerLeave,
  },
})
</script>
